import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { messageSelector, removeMessage } from "./slice";
import NotificationToast from "./components/Toast";
import NotificationPrompt from "./components/Prompt";

const renderError = (content, title, onCloseToast) =>
    content && content.includes("Unauthorized") ? (
        <NotificationPrompt
            title={title}
            body="You are not authorized to perform this action"
        />
    ) : (
        <NotificationToast
            title={title}
            onCloseToast={onCloseToast}
            body={content}
            isError
        />
    );

const renderSuccess = (content, title, onCloseToast) => (
    <NotificationToast
        title={title}
        onCloseToast={onCloseToast}
        body={content}
    />
);

const renderMessage = (isError, content, title, onCloseToast) =>
    isError
        ? renderError(content, title, onCloseToast)
        : renderSuccess(content, title, onCloseToast);

export default () => {
    const { content, isShown, isError, title } = useSelector(messageSelector);
    const _title = title || (isError ? "Something went wrong!" : "Completed");
    const [isMobileSize, setMobileSize] = useState(false);
    const dispatch = useDispatch();

    const handleIsMobile = () => {
        // eslint-disable-next-line no-magic-numbers
        const isMobile = window.innerWidth < 991;
        setMobileSize(isMobile);
    };

    // we Use this UseEffect for close toaster automaticly after 3000 M.Seconds
    useEffect(() => {
        window.addEventListener("resize", handleIsMobile);
        if (isShown && isMobileSize) {
            setTimeout(() => {
                onCloseToast();
            }, 3000);
        } else {
            console.log("nothing");
        }
    }, [isShown]);
    const onCloseToast = () => {
        dispatch(removeMessage());
    };

    return isShown && renderMessage(isError, content, _title, onCloseToast);
};
